import Link from 'next/link';
import cx from 'classnames';
import styles from './anchor-arrow.module.css';

const AnchorArrow = ({ href, openInNewTab, text, theme }) => (
  <Link href={href}>
    <a
      className={cx(linkTheme[theme], styles.link)}
      target={openInNewTab ? '_blank' : null}
    >
      <span className="font-medium">{text}</span> <span className="inline-block arrow">→</span>
    </a>
  </Link>
);

const linkTheme = {
  dark: 'text-white',
  light: 'text-link'
};

AnchorArrow.defaultProps = {
  theme: 'dark',
  href: undefined,
  openInNewTab: false
};

export default AnchorArrow;
